import { logError } from "./logger.js";

let initialized = false;

const installGlobalErrorHandlers = () => {
  if (initialized || typeof window === "undefined") {
    return;
  }

  window.addEventListener("error", (event) => {
    logError("frontend.runtime.error", {
      message: event?.message || "unknown runtime error",
      source: event?.filename || null,
      line: event?.lineno || null,
      column: event?.colno || null,
    });
  });

  window.addEventListener("unhandledrejection", (event) => {
    const reason = event?.reason;
    logError("frontend.promise.unhandled_rejection", {
      message:
        typeof reason === "string"
          ? reason
          : reason?.message || JSON.stringify(reason || "unknown rejection"),
    });
  });

  initialized = true;
};

export { installGlobalErrorHandlers };
